const work = {
    state: {
        addressID:undefined,
    },
    mutations: {
        SET_ADDRID: (state, data) => {
            state.addressID = data
        },
    },
}

export default work